"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UwRequestBuilder = void 0;
var UwRequestBuilder = /** @class */ (function () {
    function UwRequestBuilder() {
    }
    UwRequestBuilder.responseQuery = {
        payload: {
            result: null
        }
    };
    UwRequestBuilder.FollowUpQA = {
        question: null,
        answer: null,
        answerDate: null
    };
    UwRequestBuilder.FollowUpQuery = {
        questions: [__assign({}, UwRequestBuilder.FollowUpQA)],
        status: null,
        version: null,
        type: null
    };
    UwRequestBuilder.FollowUpMetadata = {
        key: null,
        questionLevel: null,
        question: null,
        type: null,
        controlType: null,
        section: null,
        actionButton: null,
        answer: null,
        answerDate: null,
        metadataKey: null,
        uwQuestion: null,
        displayOrder: null,
        responsesAllowed: null,
        isRequired: null,
        appearsBasedOn: null
    };
    UwRequestBuilder.FollowUpResponseQuery = {
        followUps: [__assign({}, UwRequestBuilder.FollowUpQuery)],
        metadata: [__assign({}, UwRequestBuilder.FollowUpMetadata)]
    };
    UwRequestBuilder.FlatExtra = {
        name: null,
        amount: null,
        ruleCode: null,
        premium: null,
        expiryAfterInYears: null
    };
    UwRequestBuilder.PremiumBreakdown = {
        base: null,
        waiver: null,
        flatExtras: [__assign({}, UwRequestBuilder.FlatExtra)]
    };
    UwRequestBuilder.PolicyRider = {
        type: null,
        amount: null,
        premiumBase: null,
        premiumWaiver: null,
        flatExtras: [__assign({}, UwRequestBuilder.FlatExtra)],
        isEligibleByUW: null,
    };
    UwRequestBuilder.ProductSwitchRestriction = {
        type: null,
    };
    UwRequestBuilder.ProductSwitch = {
        productSwitchingEnable: null,
        reasons: [__assign({}, UwRequestBuilder.ProductSwitchRestriction)]
    };
    UwRequestBuilder.UnderwritingDecision = {
        liteTouchInitialRateClass: null
    };
    UwRequestBuilder.RateClassResponseQuery = {
        acceleratedRateClass: null,
        acceleratedRateClassReasons: null,
        tLICRateClass: null,
        tLICRateClassReasons: null,
        finalAlgoRateClass: null,
        finalAlgoRateClassReasons: null,
        finalManualRateClass: null,
        finalManualRateClassReasons: null,
        finalManualRateClassReasonsComment: null,
        finalRateClass: null,
        tLICPremiumBreakdown: __assign({}, UwRequestBuilder.PremiumBreakdown),
        finalAlgoPremiumBreakdown: __assign({}, UwRequestBuilder.PremiumBreakdown),
        underwritingDecision: UwRequestBuilder.UnderwritingDecision,
        premiumBreakdown: __assign({}, UwRequestBuilder.PremiumBreakdown),
        reapplyTokensLeft: null,
        maxFace: null,
        maxFaceWholeLife: null,
        maxTerm: null,
        maxTermECP: null,
        maxAnnualPremium: null,
        maxDeathBenefit: null,
        isITM: null,
        riders: [__assign({}, UwRequestBuilder.PolicyRider)],
        secondaryAcceleratedRateClass: null,
        secondaryTLICRateClass: null,
        secondaryFinalAlgoRateClass: null,
        secondaryFinalManualRateClass: null,
        secondaryFinalRateClass: null,
        isWPEligibleByUW: null,
        productSwitch: __assign({}, UwRequestBuilder.ProductSwitch),
    };
    UwRequestBuilder.AdvActionDsSelection = {
        displayName: null,
        displayOrder: null,
        checked: null
    };
    UwRequestBuilder.AdverseActionResponseQuery = {
        notice: null,
        dsCtgSelections: [__assign({}, UwRequestBuilder.AdvActionDsSelection)]
    };
    UwRequestBuilder.ReflexiveModuleStatusResponseQuery = {
        aviationAppModuleStatus: null,
        avocationAppModuleStatus: null,
        citizenshipAppModuleStatus: null,
        rxAppModuleStatus: null,
        personalHistoryAppModuleStatus: null,
        medicalHistoryAppModuleStatus: null
    };
    UwRequestBuilder.ExamDataResponseQuery = {
        examVendor: null,
        examScheduledDate: null,
        examOrderResponse: null
    };
    UwRequestBuilder.Indication = {
        description: null,
        detailsRequired: null,
        details: null,
        isSelected: null,
        code: null,
        ratingCap: null
    };
    UwRequestBuilder.Drug = {
        codeType: null,
        code: null
    };
    UwRequestBuilder.DrugAndIndications = {
        drug: __assign({}, UwRequestBuilder.Drug),
        drugName: null,
        indications: [__assign({}, UwRequestBuilder.Indication)],
        prescriptionStartDate: Date,
        prescriptionEndDate: Date
    };
    UwRequestBuilder.ReflexiveRxDataResponseQuery = {
        policyNumber: null,
        drugsAndIndications: [__assign({}, UwRequestBuilder.DrugAndIndications)]
    };
    UwRequestBuilder.SIEligibilityResponseQuery = {
        SIAcceptancePredictor: null
    };
    UwRequestBuilder.ExamStatus = {
        policyNumber: null,
        vendor: null,
        reqStatus: null,
        reqService: null,
        StatusEventDesc: null,
        StatusEventDetail: null,
        RequestedScheduleDate: null,
        RequestedScheduleTimeStart: null,
        StatusEventDate: null,
        StatusEventTime: null,
        ProviderOrderNum: null
    };
    UwRequestBuilder.ManualUWStatusDetails = {
        actionName: null,
        createdTime: null,
        isLiteTouch: null,
        message: null,
        underwriterFirstName: null,
        underwriterLastName: null,
        underwriterEmail: null
    };
    UwRequestBuilder.ApsStatusEvent = {
        eventCode: null,
        eventDateTime: null,
        eventDetail: null,
        createdTime: null
    };
    UwRequestBuilder.ApsOrder = {
        orderId: null,
        physician: null,
        street: null,
        line1: null,
        city: null,
        state: null,
        zip: null,
        speciality: null,
        phone: null,
        source: null,
        status: null,
        createdTime: null,
        lastUpdatedTime: null,
        apsStatusEvents: [__assign({}, UwRequestBuilder.ApsStatusEvent)]
    };
    UwRequestBuilder.ManualUWStatus = {
        policyNumber: '',
        eventsDetails: [__assign({}, UwRequestBuilder.ManualUWStatusDetails)],
        apsOrders: [__assign({}, UwRequestBuilder.ApsOrder)]
    };
    UwRequestBuilder.ExamStatusResponseQuery = {
        result: [__assign({}, UwRequestBuilder.ExamStatus)]
    };
    UwRequestBuilder.ManualUWResponseQuery = {
        results: [__assign({}, UwRequestBuilder.ManualUWStatus)]
    };
    UwRequestBuilder.PolicyNumberToUnderwritingType = {
        policyNumber: '',
        underwritingType: null
    };
    UwRequestBuilder.UnderwritingTypeResponseQuery = {
        policyNumberToUnderwritingType: [__assign({}, UwRequestBuilder.PolicyNumberToUnderwritingType)]
    };
    UwRequestBuilder.CurrentStageResponseQuery = {
        currentStage: null,
        currentState: null,
        currentSubstate: null
    };
    UwRequestBuilder.RiskRate = {
        category: null,
        gate: null,
        state: null,
        rateClass: null,
        status: null,
        reasons: null,
        comment: null
    };
    UwRequestBuilder.MultiTypeRateClassResponseQuery = {
        riskRates: [__assign({}, UwRequestBuilder.RiskRate)],
        tLICPremiumBreakdown: __assign({}, UwRequestBuilder.PremiumBreakdown),
        finalAlgoPremiumBreakdown: __assign({}, UwRequestBuilder.PremiumBreakdown),
        premiumBreakdown: __assign({}, UwRequestBuilder.PremiumBreakdown),
        reapplyTokensLeft: null,
        maxFace: null,
        maxFaceWholeLife: null,
        maxTerm: null,
        maxTermECP: null,
        maxAnnualPremium: null,
        isITM: null,
        riders: [__assign({}, UwRequestBuilder.PolicyRider)],
        secondaryRiskRates: [__assign({}, UwRequestBuilder.RiskRate)]
    };
    UwRequestBuilder.IdWatchList = {
        table: null,
        recordNumber: null,
        firstName: null,
        lastName: null
    };
    UwRequestBuilder.IdCheckResult = {
        personType: null,
        result: null,
        watchLists: [__assign({}, UwRequestBuilder.IdWatchList)]
    };
    UwRequestBuilder.IdCheckDataResponseQuery = {
        policyNumber: null,
        idCheckResults: [__assign({}, UwRequestBuilder.IdCheckResult)]
    };
    UwRequestBuilder.RuleNameReason = {
        ruleName: null,
        outputScore: null,
        reason: null,
        matched: null
    };
    UwRequestBuilder.DeclineReasonsResponseQuery = {
        declineReasons: [__assign({}, UwRequestBuilder.RuleNameReason)]
    };
    UwRequestBuilder.getDefaultQueryArg = {
        underwriting: UwRequestBuilder.responseQuery,
        notifyStatusChange: UwRequestBuilder.responseQuery,
        followUps: UwRequestBuilder.FollowUpResponseQuery,
        submitFollowUps: UwRequestBuilder.responseQuery,
        rateClassFlatExtras: UwRequestBuilder.RateClassResponseQuery,
        adverseActions: UwRequestBuilder.AdverseActionResponseQuery,
        reflexiveModuleStatuses: UwRequestBuilder.ReflexiveModuleStatusResponseQuery,
        examData: UwRequestBuilder.ExamDataResponseQuery,
        reflexiveRxData: UwRequestBuilder.ReflexiveRxDataResponseQuery,
        fetchSIEligibility: UwRequestBuilder.SIEligibilityResponseQuery,
        examStatus: UwRequestBuilder.ExamStatusResponseQuery,
        manualUWStatus: UwRequestBuilder.ManualUWResponseQuery,
        underwritingType: UwRequestBuilder.UnderwritingTypeResponseQuery,
        currentStage: UwRequestBuilder.CurrentStageResponseQuery,
        multiTypeRateClass: UwRequestBuilder.MultiTypeRateClassResponseQuery,
        idCheckData: UwRequestBuilder.IdCheckDataResponseQuery,
        declineReasons: UwRequestBuilder.DeclineReasonsResponseQuery,
    };
    UwRequestBuilder.setRequest /*: Record<Required<keyof UwGqlTypes.Query>, Function>*/ = {
        underwriting: function (applicationId, msgCtx, hierarchy, product, apiSource) {
            var req = {
                context: __assign(__assign(__assign({ requestId: msgCtx.requestId, userId: apiSource || msgCtx.userId }, (msgCtx.referenceId && { referenceId: msgCtx.referenceId })), (msgCtx.referenceType && { referenceType: msgCtx.referenceType })), (msgCtx.eventName && { eventName: msgCtx.eventName })),
                payload: __assign(__assign({ applicationId: applicationId }, (hierarchy && { hierarchy: hierarchy })), (product && { product: product }))
            };
            return req;
        },
        notifyStatusChange: function (applicationId, eventName, msgCtx, apiSource) {
            return {
                context: __assign(__assign(__assign({ requestId: msgCtx.requestId, userId: apiSource || msgCtx.userId }, (msgCtx.referenceId && { referenceId: msgCtx.referenceId })), (msgCtx.referenceType && { referenceType: msgCtx.referenceType })), (msgCtx.eventName && { eventName: msgCtx.eventName })),
                payload: {
                    applicationId: applicationId,
                    eventName: eventName
                }
            };
        },
        followUps: function (policyNumber, type) {
            return {
                policyNumber: policyNumber,
                type: type
            };
        },
        submitFollowUps: function (policyNumber, followUpMetadata, physicianInfo, jwtToken) {
            return {
                policyNumber: policyNumber,
                followUpMetadata: followUpMetadata,
                physicianInfo: physicianInfo,
                jwtToken: jwtToken
            };
        },
        rateClassFlatExtras: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        adverseActions: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        reflexiveModuleStatuses: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        examData: function (applicationNumber, channel, product) {
            return {
                applicationNumber: applicationNumber,
                channel: channel,
                product: product
            };
        },
        reflexiveRxData: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        fetchSIEligibility: function (applicationNumber, channel, product) {
            return {
                applicationNumber: applicationNumber,
                channel: channel,
                product: product
            };
        },
        examStatus: function (policyNumberList, latestStatusOnly) {
            return {
                policyNumberList: policyNumberList,
                latestStatusOnly: latestStatusOnly
            };
        },
        manualUWStatus: function (policyNumberList) {
            return {
                policyNumberList: policyNumberList
            };
        },
        underwritingType: function (policyNumberList) {
            return { policyNumberList: policyNumberList };
        },
        currentStage: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        multiTypeRateClass: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        idCheckData: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
        declineReasons: function (policyNumber) {
            return { policyNumber: policyNumber };
        },
    };
    UwRequestBuilder.getClientEndpoint /*: Record<Required<keyof UwGqlTypes.Query>, keyof UnderwritingApiClient> */ = {
        underwriting: 'underwritePolicy',
        notifyStatusChange: 'notifyStatusChange',
        followUps: 'getFollowUps',
        submitFollowUps: 'submitFollowUps',
        rateClassFlatExtras: 'getRateClassFlatExtras',
        adverseActions: 'getAdverseActions',
        reflexiveModuleStatuses: 'getReflexiveModuleStatuses',
        examData: 'getExamData',
        reflexiveRxData: 'getReflexiveRxData',
        fetchSIEligibility: 'getSIEligibility',
        examStatus: 'getExamStatus',
        manualUWStatus: 'getManualUWStatus',
        underwritingType: 'getUnderwritingType',
        currentStage: 'getCurrentStage',
        multiTypeRateClass: 'getMultiTypeRateClass',
        idCheckData: 'getIdCheckData',
        declineReasons: 'getDeclineReasons',
    };
    return UwRequestBuilder;
}());
exports.UwRequestBuilder = UwRequestBuilder;
//# sourceMappingURL=UwRequestBuilder.js.map